// extracted by mini-css-extract-plugin
module.exports = {"searchInput":"SearchBox_searchInput__1wXDP","searchIcon":"SearchBox_searchIcon__1D7yw"};